import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EDeleteAllNotificationActionTypes, TDeleteAllNotificationsSucceed } from './types';

export const deleteAllSucceed: () => TDeleteAllNotificationsSucceed =
  actionGenerator<EDeleteAllNotificationActionTypes.Succeed>(EDeleteAllNotificationActionTypes.Succeed);
